import React, {PureComponent} from 'react';
import fx from 'glfx';
import intl from 'react-intl-universal';

import {applyFilters} from 'utils';

import styles from './styles';

const DEFAULT_FILTER = 'Normal';

const filters = [{
  name: DEFAULT_FILTER,
  options: {}
}, {
  name: 'The Blues',
  options: {
    blur: -14,
    brightness: 63,
    contrast: -37,
    saturation: -26,
    xpro: -23
  }
}, {
  name: 'Edge',
  options: {
    blur: -53,
    brightness: 10,
    contrast: -24,
    tint: 49,
    saturation: 26,
    xpro: 29
  }
}, {
  name: 'Selfie',
  options: {
    brightness: -10,
    contrast: -12,
    tint: -50,
    saturation: -12,
    vignette: 56,
    xpro: 50
  }
}, {
  name: 'Festive',
  options: {
    blur: -7,
    brightness: 10,
    contrast: 21,
    saturation: 24,
    vignette: 0,
    xpro: 40
  }
}, {
  name: 'Rosie',
  options: {
    blur: -14,
    contrast: 55,
    tint: -73,
    saturation: -28,
    xpro: 27
  }
}, {
  name: 'Drama',
  options: {
    brightness: -10,
    contrast: 21,
    tint: 60,
    saturation: -34,
    vignette: 50,
    xpro: 80
  }
}, {
  name: 'Epic',
  options: {
    blur: 1,
    brightness: 6,
    contrast: 20,
    saturation: -14,
    vignette: 39,
    xpro: 50
  }
}, {
  name: 'Grayscale',
  options: {
    brightness: 15,
    contrast: -20,
    saturation: -100
  }
}, {
  name: 'Nordic',
  options: {
    brightness: 15,
    contrast: -16,
    saturation: -50
  }
}, {
  name: 'Summer',
  options: {
    brightness: 10,
    contrast: 14,
    tint: -46,
    saturation: 18,
    vignette: 25,
    xpro: 30
  }
}, {
  name: 'Street',
  options: {
    blur: -7,
    brightness: -7,
    contrast: 21,
    saturation: -95,
    vignette: 50
  }
}, {
  name: 'Retro',
  options: {
    contrast: -14,
    tint: 14,
    saturation: -18,
    vignette: 40,
    xpro: 69
  }
}, {
  name: 'Whimsical',
  options: {
    blur: -19,
    brightness: 43,
    contrast: -15,
    tint: -79,
    saturation: -53,
    vignette: 21,
    xpro: 60
  }
}, {
  name: 'Cali',
  options: {
    brightness: 22,
    contrast: -46,
    saturation: 38,
    xpro: 27
  }
}];

export default class FiltersSubMenu extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      previewStatus: 'pending',
      previewMap: {}
    };
  }

  componentDidMount = () => this.generatePreviews();

  generatePreviews = () => {
    const {thumbnailImage} = this.props;
    const {previewMap} = this.state

    const filterCanvas = fx.canvas();
    const texture = filterCanvas.texture(thumbnailImage);

    filters.forEach(filter => {
      filterCanvas.draw(texture);

      const filteredCanvas = applyFilters(filterCanvas, filter.options);

      // Finally, draw the image
      filteredCanvas.update();

      previewMap[filter.name] = filteredCanvas.toDataURL('image/png');
    });

    texture.destroy();

    this.setState({
      previewMap,
      previewStatus: 'success'
    });
  };

  handleClick = (name) => () => {
    const {onChange, selectedFilter} = this.props;

    // Reset the filter
    if (name === selectedFilter) {
      name = DEFAULT_FILTER;
    }

    onChange(name, filters.find((filter) => filter.name === name).options || {});
  };

  renderOption = ({ name }) => {
    const {selectedFilter} = this.props;
    const {previewMap} = this.state
    const classes = [styles.filterOption];

    if (selectedFilter === name) {
      classes.push('selected');
    }

    return (
      <div
        key={name}
        className={classes.join(' ')}
        onClick={this.handleClick(name)}
      >
        <img alt={name} src={previewMap[name]} />
        {name}
      </div>
    );
  };

  render() {
    const {previewStatus} = this.state;

    if (previewStatus !== 'success') {
      return <div className={styles.subMenuContainer}>{intl.get('Loading...')}</div>;
    } else {
      return (
        <div className={styles.subMenuContainer}>
          {filters.map(this.renderOption)}
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/AdjustmentMenu/FiltersSubMenu.jsx